module.exports = __webpack_public_path__ + "static/media/bump-ticketlogo.b8aec6b1.png";